import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import {
  SF85, SF85P, SF85PS, SF86, SF852013
} from 'constants/formTypes';
import { isPVQForm } from 'helpers/form';
import Signature from './Signature';

export default class General extends ValidationElement {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.updateSignature = this.updateSignature.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      Signature: this.props.Signature,
      ...queue,
    });
  }

  updateSignature(values) {
    this.update({ Signature: values });
  }

  render() {
    const isPvq = isPVQForm(this.props.formType);

    return isPvq ? (
      <div className="general-release">
        <div className="generalPvq">
          <span className="headline">{i18n.m('releasesPvq.general.heading.line1')}</span>
          {i18n.m('releasesPvq.general.subHead')}
          {i18n.m('releasesPvq.general.contents')}
        </div>
        <Signature
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props.Signature}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          LegalName={this.props.LegalName}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          onError={this.props.onError}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onUpdate={this.updateSignature}
        />
      </div>
    ) : (
      <div className="general-release">
        {this.props.formType === SF86 && i18n.m('releases.general.contents')}
        {[SF852013, SF85].includes(this.props.formType) && (
          <div className="general85">
            <span className="headline">{i18n.m('releasesSF85.authorization.heading.line1')}</span>
            <span className="headline">{i18n.m('releasesSF85.authorization.heading.line2')}</span>
            <span className="headline">{i18n.m('releasesSF85.authorization.heading.line3')}</span>
            {i18n.m('releasesSF85.authorization.subHead')}
            {i18n.m('releasesSF85.authorization.contents')}
          </div>
        )}
        {[SF85P].includes(this.props.formType) && (
          <div className="general85">
            <span className="headline">{i18n.m('releasesSF85P.authorization.heading.line1')}</span>
            <span className="headline">{i18n.m('releasesSF85P.authorization.heading.line2')}</span>
            <span className="headline">{i18n.m('releasesSF85P.authorization.heading.line3')}</span>
            {i18n.m('releasesSF85P.authorization.subHead')}
            {i18n.m('releasesSF85P.authorization.contents')}
          </div>
        )}
        {[SF85PS].includes(this.props.formType) && (
          <div className="general85">
            <span className="headline">{i18n.m('releasesSF85PS.authorization.heading.line1')}</span>
            <span className="headline">{i18n.m('releasesSF85PS.authorization.heading.line2')}</span>
            <span className="headline">{i18n.m('releasesSF85PS.authorization.heading.line3')}</span>
            {i18n.m('releasesSF85PS.authorization.subHead')}
            {i18n.m('releasesSF85PS.authorization.contents')}
          </div>
        )}
        <Signature
          {...this.props.Signature}
          LegalName={this.props.LegalName}
          onUpdate={this.updateSignature} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.props.onError}
        />
      </div>
    );
  }
}

General.defaultProps = {
  Signature: {},
  LegalName: {},
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
